<template>
  <div class="create-game mb-4 pb-4">
    <StartTopBar/>
    <div class="container-sm">
      <div v-if="!loading" class="row">
        <div class="col">
          <h4 class="text-left font-weight-bold text-danger mb-4">Create new game</h4>
        </div>
      </div>

      <div class="row mb-2">
        <form class="col" v-if="!loading" @submit.prevent="createAGame">
          <div class="form-group">
            <h5 class="text-left text-font-bold">Your name:</h5>
            <input type="text" class="form-control" v-model="playerName">
            <!-- <small id="emailHelp" class="form-text text-muted">Your friends will identify you with this.</small> -->
            <h6 v-if="feedback" class="text-danger">{{ feedback }}</h6>
            <!-- <h6 class="text-left mt-1">Password:</h6>
            <input type="text" class="form-control" v-model="password"> -->
          </div>
        </form>
      </div>

      <div v-if="!loading" class="row">
        <div class="col">
          <button @click="createAGame" v-if="playerName" type="button" class="btn btn-danger rounded-lg px-5">Create game</button>
          <button v-if="!playerName" type="button" class="btn btn-secondary rounded-lg px-5" disabled>Create game</button>
        </div>
      </div>

      <div v-if="loading" class="row d-flex justify-content-center">
        <div class="spinner-border mt-3" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-if="loading" class="row d-flex justify-content-center">
        <div class="col-10 d-flex justify-content-center mt-3">
          <h6 class="text-center">This might take about 30 seconds as our servers need to warm up!</h6>
        </div>
      </div>

      <hr class="mt-4">

      <HowToPlay class="mt-2"/>

    </div>
  </div>
</template>

<script>
import firebaseApp from '@/firebase/init'
import functions from 'firebase/functions'
import StartTopBar from '@/components/StartTopBar'
import HowToPlay from '@/components/HowToPlay'

export default {
  name: 'CreateGame',
  components: {
    StartTopBar,
    HowToPlay
  },
  data(){
    return{
      playerName: null,
      // password: null,
      loading: false,
      feedback: null
    }
  },
  methods: {
    createAGame(){
      if(this.playerName){
        this.loading = true
        const masterFunction = firebaseApp.functions('asia-northeast1').httpsCallable('masterFunction')
        masterFunction({
          methodName: 'createGame',
          playerName: this.playerName,
          // password: this.password
        }).then(result => {
          this.$router.push({ name: 'Game', params: {
            playerCode: result.data.playerCode,
            gameCode: result.data.gameCode
          }})
          this.playerName = null
        }).catch(err => {
          this.loading = false
          this.feedback = 'Got some server issue, maybe try again?'
        });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CreateGame.vue